import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { renameFile } from '@widgets/Files/api/renameFile';
import { handleStatusError } from '@widgets/Files/helpers/handleStatusError';

export const useRenameFile = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation({
        mutationKey: ['renameFile'],
        mutationFn: renameFile,
        onSuccess: (data) => {
            handleStatusError(
                data?.response?.data,
                t('useFileUpload.return.swal.manyFiles.button')
            );
            if (data.status === 'success') {
                queryClient.invalidateQueries({ queryKey: ['files'] });
            }
        },
    });
};
